import { KeyEmpty, KeyBase, IIsDefined } from '@kpd/framework-ngx';

export class PermissionsetKey extends KeyBase implements IIsDefined {
  static composeKeyByRouteParams(params: { permissionSetId: string; applicationId: string; type?: string }): KeyBase {
    if (params.permissionSetId === '0' && params.applicationId === '0') {
      return new KeyEmpty();
    }
    return new PermissionsetKey(params.permissionSetId, params.applicationId, !!params.type);
  }

  constructor(
    public permissionSetId: string,
    public applicationId: string,
    public isGlobalPermission: boolean = false,
  ) {
    super();
  }

  toString(): string {
    if (this.permissionSetId === '0' && this.applicationId === '0') {
      return '0'; // New entity
    }
    return `${this.permissionSetId}:${this.applicationId}${this.isGlobalPermission ? ':global' : ''}`;
  }

  isDefined(): boolean {
    return !!this.permissionSetId || !!this.applicationId;
  }
}
